export const languages = [
  {
    Language: 'Amharic',
    Code: 'am'
  },
  {
    Language: 'Arabic',
    Code: 'ar'
  },
  {
    Language: 'Bangla',
    Code: 'bn'
  },
  {
    Language: 'Belarusian',
    Code: 'be'
  },
  {
    Language: 'Bulgarian',
    Code: 'bg'
  },
  {
    Language: 'Chinese (Hong Kong)',
    Code: 'yue-hant'
  },
  {
    Language: 'Chinese (Simplified)',
    Code: 'zh'
  },
  {
    Language: 'Chinese (Traditional)',
    Code: 'zh-hant'
  },
  {
    Language: 'English',
    Code: 'en'
  },
  {
    Language: 'French',
    Code: 'fr'
  },
  {
    Language: 'German',
    Code: 'de'
  },
  {
    Language: 'Greek',
    Code: 'el'
  },
  {
    Language: 'Gujarati',
    Code: 'gu'
  },
  {
    Language: 'Hebrew',
    Code: 'he'
  },
  {
    Language: 'Hindi',
    Code: 'hi'
  },
  {
    Language: 'Italian',
    Code: 'it'
  },
  {
    Language: 'Japanese',
    Code: 'ja'
  },
  {
    Language: 'Kannada',
    Code: 'kn'
  },
  {
    Language: 'Malayalam',
    Code: 'ml'
  },
  {
    Language: 'Marathi',
    Code: 'mr'
  },
  {
    Language: 'Nepali',
    Code: 'ne'
  },
  {
    Language: 'Odia',
    Code: 'or'
  },
  {
    Language: 'Persian',
    Code: 'fa'
  },
  {
    Language: 'Portuguese (Brazil)',
    Code: 'pt'
  },
  {
    Language: 'Punjabi',
    Code: 'pa'
  },
  {
    Language: 'Russian',
    Code: 'ru'
  },
  {
    Language: 'Sanskrit',
    Code: 'sa'
  },
  {
    Language: 'Serbian',
    Code: 'sr'
  },
  {
    Language: 'Sinhala',
    Code: 'si'
  },
  {
    Language: 'Spanish',
    Code: 'es'
  },
  {
    Language: 'Tamil',
    Code: 'ta'
  },
  {
    Language: 'Telugu',
    Code: 'te'
  },
  {
    Language: 'Tigrinya',
    Code: 'ti'
  },
  {
    Language: 'Ukrainian',
    Code: 'uk'
  },
  {
    Language: 'Urdu',
    Code: 'ur'
  },
  {
    Language: 'Vietnamese',
    Code: 'vi'
  }
];
